var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 7 5",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.638565 2.42697C1.04473 1.37241 2.06755 0.625 3.26416 0.625V0C1.80054 0 0.551312 0.914585 0.0553312 2.20231L0.638565 2.42697ZM3.26416 0.625C4.46075 0.625 5.48357 1.37241 5.88972 2.42697L6.47297 2.20231C5.97697 0.914588 4.72775 0 3.26416 0V0.625ZM5.88972 2.57303C5.48357 3.62759 4.46075 4.375 3.26416 4.375V5C4.72775 5 5.97697 4.08541 6.47297 2.79769L5.88972 2.57303ZM3.26416 4.375C2.06755 4.375 1.04473 3.62759 0.638565 2.57303L0.0553312 2.79769C0.551312 4.08541 1.80054 5 3.26416 5V4.375ZM5.88972 2.42697C5.90782 2.47391 5.90782 2.52609 5.88972 2.57303L6.47297 2.79769C6.54675 2.60612 6.54675 2.39388 6.47297 2.20231L5.88972 2.42697ZM0.0553312 2.20231C-0.0184437 2.39388 -0.0184437 2.60612 0.0553312 2.79769L0.638565 2.57303C0.620478 2.52609 0.620478 2.47391 0.638565 2.42697L0.0553312 2.20231Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26416 1.875C2.91898 1.875 2.63916 2.15482 2.63916 2.5C2.63916 2.84518 2.91898 3.125 3.26416 3.125C3.60934 3.125 3.88916 2.84518 3.88916 2.5C3.88916 2.15482 3.60934 1.875 3.26416 1.875ZM2.01416 2.5C2.01416 1.80964 2.5738 1.25 3.26416 1.25C3.95452 1.25 4.51416 1.80964 4.51416 2.5C4.51416 3.19036 3.95452 3.75 3.26416 3.75C2.5738 3.75 2.01416 3.19036 2.01416 2.5Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeView);
export default __webpack_public_path__ + "static/media/eye-view.65785896e80aca219c252d1c61784cb0.svg";
export { ForwardRef as ReactComponent };